module.exports = __webpack_public_path__ + "static/media/IMG_5582.08bf2446.JPG";